<template>
  <div>
    <info-generales :ordreTravail="ordreTravail"></info-generales>
    <taches :ordre-travail="ordreTravail" class="mgt-20px"></taches>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>{{ $t('piecesJointes.attachments')}}</p>
      </header>
      <div class="card-content">
        <pieces-jointes :checkPermissions="true"/>
      </div>
    </div>
  </div>
</template>

<script>

import infoGenerales
  from '@/components/logistique/ordreTravail/tech/addEdit/caracteristique/infoGenerales';
import taches from '@/components/logistique/ordreTravail/tech/addEdit/caracteristique/taches';
import piecesJointes from '@/components/general/piecesJointes';

export default {
  name: 'LogistiqueOrdreTravailTechniqueEditAddCaracteristique',
  props: {
    ordreTravail: {
      type: Object,
      required: true,
    },
  },
  components: {
    infoGenerales,
    taches,
    piecesJointes,
  },
};

</script>
